import * as React from 'react'
import Grid from '@mui/material/Grid';
import { Button, FormControl, FormControlLabel, Stack, Switch, TextField, Typography } from '@mui/material';
import { useLoaderData, useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { UserResp, UserTenantInfo } from '../../api';
import * as yup from "yup"
import UnstyledLink from '../../components/common/UnstyledLink/UnstyledLink';
import { usersApi } from '../../api-interface';
import { useContext, useState } from 'react';
import { TenantContext } from '../..';
import { useSnackbar } from 'notistack';


const UserAdd = () => {

    const { enqueueSnackbar } = useSnackbar();

    const currentTenant = useContext(TenantContext)
    const navigate = useNavigate()

    const schema = yup
        .object({
            email: yup.string().required().email(),
            user_management: yup.bool(),
        })
        .required()

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    })

    const [apiError, setApiError] = useState<string>("")

    const handleNewUser = async (x) => {
        try{
            await usersApi(currentTenant).addUserUsersPost(
                {
                    email: x.email,
                    user_management: x.user_management
                }
            )
            enqueueSnackbar('User added', {variant:"success"})
            navigate("/dashboard/"+currentTenant+"/users")
        } catch(e){
            if (e?.response?.data?.detail){
                setApiError(e.response.data.detail)
            } else{
                throw e
            }
        }
    }


    return (
        <Grid size={{xs:11}}>
            <Grid rowSpacing={2} container>
                <Grid size={{xs:12}}>
                    <Typography variant="h4" > Add new user </Typography>
                </Grid>
                <Grid size={{xs:12, sm: 12, md: 12, lg:8, xl:4}}>
                    <form onSubmit={handleSubmit(handleNewUser)}>
                        <FormControl fullWidth>
                            <Typography marginTop={3} variant='subtitle1'>User Details</Typography>
                            <TextField
                                margin="normal"
                                label="Email Address"
                                placeholder="Email Address"
                                {...register('email')}
                                error={errors.email ? true : false}
                                helperText={errors.email?.message?.toString()}
                                type="text"
                                variant='outlined'
                                required
                            />
                        </FormControl>
                        <FormControl>
                            <Typography marginTop={3} variant='subtitle1'>User Permissions</Typography>
                            <FormControlLabel
                                control={
                                    <Switch
                                        defaultChecked={false}
                                        {...register('user_management')}
                                     />
                                }
                                label="User Management" />
                            <Stack marginTop={5} spacing={2} direction="row">
                                <UnstyledLink to=".." relative="path"><Button variant="outlined" >Cancel</Button></UnstyledLink>
                                <Button variant="contained" type="submit">Save</Button>
                            </Stack>
                            <Typography mt={2} color="error" align="center" display={apiError ? "block" : "none"}>
                                        {apiError}
                        </Typography>
                        </FormControl>

                    </form>

                </Grid>
            </Grid>
        </Grid>
    )
}

export default UserAdd